import React, { useState, useEffect } from "react";

export default function QuestionPapers() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px",
        marginTop:
          windowWidth < 768 ? "50px" : windowWidth < 1300 ? "150px" : "300px",
        marginBottom: "50px",
      }}
    >
      <h1 style={{ textAlign: "center", color: "#162544" }}>Question Papers</h1>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          padding: "20px",
          width:
            windowWidth < 768 ? "100%" : windowWidth < 1300 ? "90%" : "70%",
        }}
      >
        {/* School of Engineering */}
        <h2
          style={{
            marginTop: "20px",
            color: "#162544",
            fontSize: windowWidth < 768 ? "1rem" : "1.5rem",
          }}
        >
          Engineering
        </h2>
        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "20px",
            marginTop: "10px",
          }}
        >
          <li style={{ padding: "10px 0" }}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://jssuninoida.edu.in/assets/docs/DEC_2024_B.TECH.pdf"
              style={{ fontSize: windowWidth < 768 ? "0.9rem" : "1rem" }}
            >
              B.Tech 2024-25 First Year
            </a>
          </li>
        </ul>

        {/* School of Pharmacy */}
        <h2
          style={{
            marginTop: "20px",
            color: "#162544",
            fontSize: windowWidth < 768 ? "1rem" : "1.5rem",
          }}
        >
          Pharmacy
        </h2>
        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "20px",
            marginTop: "10px",
          }}
        >
          <li style={{ padding: "10px 0" }}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://jssuninoida.edu.in/assets/docs/DEC_2024_B.PHARM.pdf"
              style={{ fontSize: windowWidth < 768 ? "0.9rem" : "1rem" }}
            >
              B.Pharm 2024-25 First Year
            </a>
          </li>
        </ul>

        {/* School of Commerce & Management Studies */}
        <h2
          style={{
            marginTop: "20px",
            color: "#162544",
            fontSize: windowWidth < 768 ? "1rem" : "1.5rem",
          }}
        >
        MCA
        </h2>
        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "20px",
            marginTop: "10px",
          }}
        >
          <li style={{ padding: "10px 0" }}>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://jssuninoida.edu.in/assets/docs/DEC_2024_MCA.pdf"
              style={{ fontSize: windowWidth < 768 ? "0.9rem" : "1rem" }}
            >
              MCA 2024-25 First Year
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
